// ES
export const listingRatesManager = {
  header: {
    eyebrow: "Tarifas derivadas",
    title: "Tarifas del anuncio",
    subtitle:
      "Centraliza la configuracion de tarifas y aplicala a las unidades que necesites, incluso en varios anuncios, sin repetir el trabajo una por una.",
    newRate: "Nueva tarifa",
  },
  baseInfo: {
    title: "Precios base por noche",
    perNight: "/ noche",
    hint: "Las tarifas derivadas se calculan como ajuste (% o importe fijo) sobre estos precios base.",
  },
  states: {
    loading: "Cargando tarifas del anuncio...",
    emptyTitle: "Sin tarifas derivadas todavía",
    emptyText:
      "Crea una tarifa derivada para sincronizar precios con canales como Booking.com o Airbnb.",
    createFirst: "Crear primera tarifa",
  },
  group: {
    unitsCount: "{count} unidad | {count} unidades",
    manageTitle: "Gestionar grupo de tarifas",
    manage: "Gestionar",
    modalTitle: "Gestionar tarifa",
    apply: "Aplicar",
    appliedUnits: "Unidades donde está aplicada",
    removeSyncedWarn:
      "Esta tarifa está conectada al canal. Al quitarla se eliminará del canal también.",
    removeConfirm: "¿Confirmas quitar esta tarifa de esta unidad?",
    removing: "Quitando...",
    confirmRemove: "Sí, quitar",
    removeTitle: "Quitar de esta unidad",
    remove: "Quitar",
  },
  chips: {
    connect: "Connect",
    paused: "Pausada",
    syncedTitle: "Sincronizada con el canal",
  },
  actions: {
    editTitle: "Editar tarifa",
    duplicateTitle: "Duplicar o copiar",
    pause: "Pausar ventas",
    resume: "Reanudar ventas",
    deleteTitle: "Eliminar",
  },
  modal: {
    createTitle: "Nueva tarifa derivada",
    editTitle: "Editar tarifa",
    importPlaceholder: "Copiar de tarifa existente…",
    namePlaceholder: "Nombre de la tarifa",
    percentage: "% Porcentaje",
    fixed: "Valor fijo",
    derivationHint: "Negativo reduce el precio base, positivo lo sube.",
    searchPlaceholder: "Buscar…",
    unitsCounter: "{selected} / {total} unidades",
    selectAll: "Seleccionar todo",
    deselectAll: "Quitar todo",
    loadingUnits: "Cargando…",
    currentBadge: "Actual",
    unitsWithRate: "{count} unidad con tarifa | {count} unidades con tarifa",
    noBaseRate: "Sin tarifa base",
    noResults: 'Sin resultados para "{query}"',
    create: "Crear tarifa",
    creating: "Creando…",
    save: "Guardar",
    saving: "Guardando…",
  },
  delete: {
    title: "Eliminar tarifa derivada",
    subtitle: "Confirma el nombre para evitar borrar una tarifa por error.",
    confirmCopy: "Escribe el nombre de la tarifa para confirmar:",
    deleting: "Eliminando...",
  },
  types: {
    apartment: "Apartamento",
    house: "Casa",
    villa: "Villa",
    hotel: "Hotel",
    room: "Habitacion",
    studio: "Estudio",
    camping: "Camping",
    default: "Alojamiento",
  },
  misc: {
    noName: "Sin nombre",
    unitFallback: "Unidad #{id}",
    basePrefix: "Base:",
  },
  common: {
    cancel: "Cancelar",
    delete: "Eliminar",
    close: "Cerrar",
  },
  toasts: {
    loadError: "Error al cargar las tarifas del anuncio",
    loadListingsError: "Error al cargar los anuncios",
    selectUnit: "Selecciona al menos una unidad con tarifa base.",
    created: "Tarifa creada correctamente",
    createdPartial: "Algunas tarifas no se pudieron crear",
    createError: "Error al crear la tarifa",
    updated: "Tarifa actualizada correctamente",
    updateError: "No se pudo actualizar la tarifa",
    updateErrorGeneric: "Error al actualizar la tarifa",
    deleted: "Tarifa eliminada",
    deleteError: "Error al eliminar",
    groupUpdated:
      "Tarifa actualizada en {count} unidad | Tarifa actualizada en {count} unidades",
    groupUpdatedPartial: "{success} actualizada(s), {error} con error",
    removedFromUnit: "Tarifa quitada de esta unidad",
    removeError: "No se pudo quitar la tarifa",
    removeErrorGeneric: "Error al quitar la tarifa",
    toggleError: "Error al cambiar el estado de la tarifa",
  },
};
